import { PriceCalculationDTO } from '../../dto';
import { MgPackageClassCode } from '@retail/products/types';
import { DatedBracketMarkupPrice } from './DatedBracketMarkupPrice';

export type PriceResultType = 'CALCULATION' | 'PRICE_SUGGESTION' | 'CUSTOMER';

export interface PriceCalculationProps {
  salesBracketPrices?: DatedBracketMarkupPrice[];
}

export class PriceCalculation {
  salesBracketPrices?: DatedBracketMarkupPrice[];

  constructor(props: PriceCalculationProps) {
    this.salesBracketPrices = props.salesBracketPrices;
  }

  getBracketPackagePrice = (
    bracketClassCode: MgPackageClassCode
  ): DatedBracketMarkupPrice | undefined =>
    this.salesBracketPrices?.find(
      ({ bracketMarkupPrice }) =>
        bracketMarkupPrice.calculationPackage.classCode === bracketClassCode
    );

  static fromDto = (dto: PriceCalculationDTO | undefined): PriceCalculation => {
    return new PriceCalculation({
      salesBracketPrices: dto?.salesBracketPrices
        ? dto?.salesBracketPrices.map(DatedBracketMarkupPrice.fromDto)
        : undefined,
    });
  };
}
